import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/App";
import { PwaStatusAdapter } from "@/platform/pwa";
import "@/styles/global.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <PwaStatusAdapter />
  </StrictMode>
);
